import { render, staticRenderFns } from "./SfProperty.vue?vue&type=template&id=32a4ed30&functional=true&"
import script from "./SfProperty.vue?vue&type=script&lang=ts&"
export * from "./SfProperty.vue?vue&type=script&lang=ts&"
import style0 from "./SfProperty.vue?vue&type=style&index=0&id=32a4ed30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports